import React, { useEffect } from "react";
import { NavLink, useLocation } from "react-router-dom";
import EmailIcon from "../../assets/images/Icon_Email.png";
import Address from "../../assets/images/Icon_Address.png";
import PhoneIcon from "../../assets/images/Icon_Phone.png";
import CloseIcon from "../../assets/images/closeIcon.png";

const MobileMenu = () => {
  const location = useLocation();
  const normalizedPath = location.pathname.replace(/\/+$/, "") || "/";
  const isServicePath =
    normalizedPath === "/services" || normalizedPath.startsWith("/service/");
  const isProjectPath = normalizedPath === "/projects" || normalizedPath === "/project";
  const isMediaPath = normalizedPath === "/media" || normalizedPath.startsWith("/media/");

  const closeMobileMenu = () => {
    const offcanvasMobileMenu = document.querySelector(
      "#offcanvas-mobile-menu"
    );
    if (offcanvasMobileMenu) {
      offcanvasMobileMenu.classList.remove("active");
    }
  };

  const sideMenuExpand = e => {
    e.currentTarget.parentElement.classList.toggle("active");
  };

  useEffect(() => {
    const offCanvasNav = document.querySelector("#offcanvas-navigation");
    if (!offCanvasNav) return undefined;

    const offCanvasNavSubMenu = offCanvasNav.querySelectorAll(`.subMenu`);
    const anchorLinks = offCanvasNav.querySelectorAll("a");
    const handleAnchorClick = () => closeMobileMenu();

    for (let i = 0; i < offCanvasNavSubMenu.length; i++) {
      const hasExpand = offCanvasNavSubMenu[i].previousElementSibling?.classList?.contains("menuExpand");
      if (!hasExpand) {
        offCanvasNavSubMenu[i].insertAdjacentHTML(
          "beforebegin",
          `<span class="menuExpand"><i></i></span>`
        );
      }
    }

    const menuExpand = offCanvasNav.querySelectorAll(".menuExpand");
    menuExpand.forEach((item) => item.addEventListener("click", sideMenuExpand));

    for (let i = 0; i < anchorLinks.length; i++) {
      anchorLinks[i].addEventListener("click", handleAnchorClick);
    }

    return () => {
      menuExpand.forEach((item) => item.removeEventListener("click", sideMenuExpand));
      for (let i = 0; i < anchorLinks.length; i++) {
        anchorLinks[i].removeEventListener("click", handleAnchorClick);
      }
    };
  }, [location.pathname]);

  return (
    <div className="offcanvasMobileMenu" id="offcanvas-mobile-menu">
      <button
        className="offcanvasMenuClose"
        id="mobile-menu-close-trigger"
        onClick={() => closeMobileMenu()}
      >
      {/* <i className="icon-glyph-146"></i> */}
      {/* <i class="fa fa-close"></i> */}
      <img src={CloseIcon} className="img-fluid" alt="img"/>
      </button>

      <div className="offcanvasWrapper">
        <div className="offcanvasInnerContent">

          <nav className="offcanvasNavigation" id="offcanvas-navigation">
            <ul>
              <li>
                <NavLink exact to="/" activeClassName="active-link">Home</NavLink>
              </li>
              <li>
                <NavLink to="/about" activeClassName="active-link">
About Us</NavLink>
              </li>
              <li>
                <NavLink to="/services" className={isServicePath ? "active-link" : ""}>
                Services
                </NavLink>
                <ul className="subMenu">
                  <li>
                    <NavLink to="/services#drilling-services">Drilling Services</NavLink>
                  </li>
                  <li>
                    <NavLink to="/services#workover-completion">Workover &amp; Completion</NavLink>
                  </li>
                  <li>
                    <NavLink to="/services#operation-maintenance">O&amp;M</NavLink>
                  </li>
                  <li>
                    <NavLink to="/services#oilfield-equipment">Oilfield Equipment</NavLink>
                  </li>
                  <li>
                    <NavLink to="/services#manpower-supply">Manpower Supply</NavLink>
                  </li>
                </ul>
              </li>
              <li>
                <NavLink to="/industries" activeClassName="active-link">
                Industries
                </NavLink>
              </li>
              <li>
                <NavLink to="/overseas-recruitment" activeClassName="active-link">
                Recruitment
                </NavLink>
              </li>
              <li>
                <NavLink to="/projects" className={isProjectPath ? "active-link" : ""}>
                Projects
                </NavLink>
              </li>
              <li>
                <NavLink to="/equipment" activeClassName="active-link">
                Equipment
                </NavLink>
              </li>
              <li>
                <NavLink to="/clients" activeClassName="active-link">
                Clients
                </NavLink>
              </li>
              <li>
                <NavLink to="/careers" activeClassName="active-link">
                Careers
                </NavLink>
              </li>
              <li>
                <NavLink to="/media" className={isMediaPath ? "active-link" : ""}>
                Media
                </NavLink>
                <ul className="subMenu">
                  <li><NavLink to="/media/blog">Blogs</NavLink></li>
                  <li><NavLink to="/media/news">News</NavLink></li>
                </ul>
              </li>
              <li>
                <NavLink
                  to="/gallery"
                  className={normalizedPath === "/gallery" || normalizedPath === "/gallery-two" ? "active-link" : ""}
                >
                Gallery
                </NavLink>
              </li>
              <li>
                <NavLink to="/contact" activeClassName="active-link">
                Contact
                </NavLink>
              </li>
            </ul>
          </nav>

          {/* Search Form */}
          {/* <div className="offcanvasMobileSearchArea">
            <form action="#">
              <input type="search" placeholder="Search ..." />
              <button type="submit"> 
              </button>
            </form>
          </div> */}

          {/* Contact Info  */} 

          <div className="header_top_right list-unstyled">
            <ul>
              <li className="d-flex align-items-center ">
              {/* <i className="fa fa-phone"></i>  */}
              <img src={PhoneIcon} alt="" className="img-fluid" />
              <a href="tel:+919316305258" className="mx-2">+91 9316305258</a>
              </li>
              <li className="d-flex align-items-center ">
              <img src={EmailIcon} alt="" className="img-fluid" />

              
              <a href="mailto:info@southasiaconsultancy.com" className="mx-2">
                        info@southasiaconsultancy.com
                      </a>
              </li>
              <li className="d-flex align-items-start ">
              <img src={Address} alt="" className="img-fluid mt-1" />
              <div className="ml-1 text-justify">
                <a
                  href="https://www.google.com/maps?q=1209,+12th+Floor,+Hubtown+Viva+Building,+Near+Mogra+Metro+Station,+Jogeshwari+East,+Mumbai+400060"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="d-block mb-2"
                >
                  <strong>Mumbai:</strong> 1209, 12th Floor, Hubtown Viva Building,
                  Near Mogra Metro Station, Jogeshwari East, Mumbai – 400060
                </a>
                <a
                  href="https://www.google.com/maps?q=402,+Orange+Mall,+Mehsana+Highway,+above+HDFC+Bank,+Nigam+Nagar,+Chandkheda,+Ahmedabad,+Gujarat+382424"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="d-block"
                >
                  <strong>Ahmedabad:</strong> 402, Orange Mall, Mehsana Highway,
                  above HDFC Bank, Nigam Nagar, Chandkheda, Ahmedabad, Gujarat 382424
                </a>
              </div>
              </li>
            </ul>
          </div>

      

        </div>
      </div>
    </div>
  );
};

export default MobileMenu;
